const description = {
    email: 'e-mail',
    phone_number: 'telefonní číslo',
    username: 'uživatelské jméno',
    reminder: 'Připomenutí',
    not_found: '404 Nenalezeno',
    agree_with_terms: 'Přečetl/a jsem si a souhlasím s ',
    agree_with_terms_modal: 'Pro pokračování prosím souhlas s <link></link>.',
    terms_of_use: 'Podmínky použití',
    sign_in: 'Přihlásit se',
    privacy_policy: 'Zásady ochrany soukromí',
    create_account: 'Vytvořit účet',
    switch_account: 'Přepnout účet',
    or: 'nebo',
    and: 'a',
    enter_passcode: 'Ověřovací kód byl odeslán na tvou {{address}} {{target}}',
    passcode_sent: 'Ověřovací kód byl znovu odeslán',
    resend_after_seconds: 'Stále jsi ho neobdržel/a? Odeslat znovu za <span>{{seconds}}</span> sekund',
    resend_passcode: 'Stále jsi ho neobdržel/a? <a>Odeslat ověřovací kód znovu</a>',
    create_account_id_exists: 'Účet s {{value}} již existuje. Pokračuj v přihlášení.',
    link_account_id_exists: 'Účet s {{type}} {{value}} již existuje. Chceš ho propojit?',
    sign_in_id_does_not_exist: 'Pro {{value}} nebyl nalezen žádný účet. Chceš vytvořit nový?',
    sign_in_id_does_not_exist_alert: 'Účet s {{type}} {{value}} neexistuje.',
    create_account_id_exists_alert: 'Účet s {{type}} {{value}} je propojen s jiným účtem. Zkus prosím jiný {{type}}.',
    social_identity_exist: '{{type}} {{value}} je propojen s jiným účtem. Zkus prosím jiný {{type}}.',
    bind_account_title: 'Propojit nebo vytvořit účet',
    social_create_account: 'Můžeš vytvořit nový účet.',
    social_link_email: 'Můžeš propojit jiný e-mail',
    social_link_phone: 'Můžeš propojit jiné telefonní číslo',
    social_link_email_or_phone: 'Můžeš propojit jiný e-mail nebo telefonní číslo',
    social_bind_with_existing: 'Našli jsme související účet, který byl již registrován, a můžeš ho propojit přímo.',
    skip_social_linking: 'Přeskočit propojení s existujícím účtem?',
    reset_password: 'Obnovit heslo',
    reset_password_description: 'Zadej {{types, list(type: disjunction;)}} propojené s tvým účtem a pošleme ti ověřovací kód pro obnovení hesla.',
    reset_password_magic_link_description: 'Zadejte e-mailovou adresu přiřazenou k vašemu účtu, abyste mohli pokračovat v resetování hesla.',
    new_password: 'Nové heslo',
    set_password: 'Nastavit heslo',
    password_changed: 'Heslo bylo změněno',
    no_account: 'Ještě nemáš účet? ',
    have_account: 'Už máš účet?',
    enter_password: 'Zadej heslo',
    enter_password_for: 'Přihlas se pomocí hesla k {{method}} {{value}}',
    enter_username: 'Nastavit uživatelské jméno',
    enter_username_description: 'Uživatelské jméno slouží jako alternativa pro přihlášení. Mělo by obsahovat pouze písmena, čísla a podtržítka.',
    enter_username_policy_description: 'Uživatelské jméno slouží jako alternativa pro přihlášení. {{requirements}}',
    link_email: 'Propojit e-mail',
    link_phone: 'Propojit telefonní číslo',
    link_email_or_phone: 'Propojit e-mail nebo telefonní číslo',
    link_email_description: 'Pro zvýšení bezpečnosti, prosím, propoj svůj e-mail s účtem.',
    link_phone_description: 'Pro zvýšení bezpečnosti, prosím, propoj své telefonní číslo s účtem.',
    link_email_or_phone_description: 'Pro zvýšení bezpečnosti, prosím, propoj svůj e-mail nebo telefonní číslo s účtem.',
    continue_with_more_information: 'Pro zvýšení bezpečnosti, prosím, vyplň níže údaje k účtu.',
    create_your_account: 'Vytvoř si účet',
    sign_in_to_your_account: 'Přihlas se ke svému účtu',
    device_activation: 'Aktivace zařízení',
    device_activation_description: 'Zadej kód zobrazený na tvém zařízení. Ujisti se, že se shoduje, a poté pokračuj v přihlášení k tomuto zařízení.',
    device_activation_error_description: 'Zadej kód zobrazený na tvém zařízení.',
    device_activation_success: 'Tvoje zařízení je nyní připojeno!',
    device_activation_success_description: 'Vrať se na své zařízení pro pokračování.',
    no_region_code_found: 'Telefonní předvolba nebyla nalezena',
    verify_email: 'Ověř svůj e-mail',
    verify_phone: 'Ověř své telefonní číslo',
    password_requirements: 'Heslo {{items, list}}.',
    password_requirement: {
        length_one: 'vyžaduje alespoň {{count}} znak',
        length_two: 'vyžaduje alespoň {{count}} znaky',
        length_few: 'vyžaduje alespoň {{count}} znaky',
        length_many: 'vyžaduje alespoň {{count}} znaků',
        length_other: 'vyžaduje alespoň {{count}} znaků',
        character_types_one: 'musí obsahovat alespoň {{count}} typ velkých písmen, malých písmen, číslic a symbolů',
        character_types_two: 'musí obsahovat alespoň {{count}} typy velkých písmen, malých písmen, číslic a symbolů',
        character_types_few: 'musí obsahovat alespoň {{count}} typy velkých písmen, malých písmen, číslic a symbolů',
        character_types_many: 'musí obsahovat alespoň {{count}} typů velkých písmen, malých písmen, číslic a symbolů',
        character_types_other: 'musí obsahovat alespoň {{count}} typů velkých písmen, malých písmen, číslic a symbolů',
    },
    username_requirements: 'Uživatelské jméno {{items, list}}.',
    username_requirement: {
        length: 'musí mít {{min}} až {{max}} znaků',
        characters: 'může obsahovat pouze {{characters, list}}',
    },
    username_character: {
        uppercase: 'velká písmena',
        lowercase: 'malá písmena',
        number: 'číslice',
        underscore: 'podtržítka',
    },
    use: 'Použít',
    single_sign_on_email_form: 'Zadej svou firemní e-mailovou adresu',
    single_sign_on_connectors_list: 'Tvá firma povolila jednotné přihlašování (Single Sign-On) pro e-mailový účet {{email}}. Můžeš pokračovat přihlášením přes následující poskytovatele SSO.',
    single_sign_on_enabled: 'Single Sign-On je povoleno pro tento účet',
    authorize_title: 'Autorizovat {{name}}',
    request_permission: '{{name}} žádá o přístup k:',
    grant_organization_access: 'Udělit organizaci přístup:',
    authorize_personal_data_usage: 'Povolit použití tvých osobních údajů:',
    authorize_organization_access: 'Povolit přístup konkrétní organizaci:',
    user_scopes: 'Osobní údaje uživatele',
    organization_scopes: 'Přístup organizace',
    authorize_agreement: `Povolením přístupu souhlasíš s {{name}} <link></link>.`,
    authorize_agreement_with_redirect: `Povolením přístupu souhlasíš s {{name}} <link></link> a budeš přesměrován/a na {{uri}}.`,
    not_you: 'Nejsi to ty?',
    user_id: 'ID uživatele: {{id}}',
    redirect_to: 'Budeš přesměrován/a na {{name}}.',
    auto_agreement: 'Pokračováním souhlasíš s <link></link>.',
    identifier_sign_in_description: 'Zadej své {{types, list(type: disjunction;)}} pro přihlášení.',
    all_sign_in_options: 'Všechny možnosti přihlášení',
    identifier_register_description: 'Zadej své {{types, list(type: disjunction;)}} pro vytvoření nového účtu.',
    all_account_creation_options: 'Všechny možnosti vytvoření účtu',
    password_expired: 'Platnost vašeho hesla vypršela a před přihlášením musí být resetováno.',
    password_expiration_reset: 'Resetovat heslo',
    back_to_sign_in: 'Zpět k přihlášení',
    support_email: 'E-mail podpory: <link></link>',
    support_website: 'Webová stránka podpory: <link></link>',
    switch_account_title: 'Momentálně jsi přihlášen/a jako {{account}}',
    switch_account_description: 'Pro pokračování budeš odhlášen/a z aktuálního účtu a automaticky přepnut/a na nový účet.',
    about_yourself: 'Řekni nám něco o sobě',
    verify_identity: 'Ověř svou identitu',
    choose_verification_method: 'Vyber, jak se chceš přihlásit',
    verification_method: {
        passkey: 'Přístupový klíč',
        passkey_description: 'Ověř pomocí svého zařízení nebo USB klíče',
        password: 'Heslo',
        password_description: 'Zadej své heslo',
        email_verification_code: 'Ověřovací kód e-mailem',
        phone_verification_code: 'Ověřovací kód SMS',
        verification_code_description: 'Odeslat na {{target}}',
    },
};
export default Object.freeze(description);
